var _defs, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHamburger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hamburgerIcon",
    "data-name": "b0cc017e-06ae-4da6-a507-9553d413583d",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            line {fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}\n        "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "top-bar",
    x1: 4.0421,
    y1: 9.0347,
    x2: 45.9578,
    y2: 9.0347
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "middle-bar",
    x1: 4.0417,
    y1: 25,
    x2: 45.9574,
    y2: 25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "bottom-bar",
    x1: 4.0421,
    y1: 40.9653,
    x2: 45.9578,
    y2: 40.9653
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburger);
export default __webpack_public_path__ + "static/media/hamburger.8411ab34.svg";
export { ForwardRef as ReactComponent };